module.exports = {
  src: __webpack_public_path__ + "static/media/weddings_00003.b4c57e25.jpg",
  width: 2000,
  height: 2400,
  bytes: 289807,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/weddings_00003.b4c57e25.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/weddings/weddings_00003.jpg
// module id = 491
// module chunks = 0